module.exports = __webpack_public_path__ + "img/patrick_star.24dacda7.jpg";